import { render } from "./App.vue?vue&type=template&id=e963df36"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e963df36&lang=css"
script.render = render

export default script